export enum StagiaireStatus {
    Independant = "Indépendant",
    Associe = "Associé"
}

export interface Stagiaire {
    id: number;
    nomStructure: string | null;
    nomUsagePro: string | null;
    titreProfil: string | null;
    presentation: string | null;
    sexe: "M" | "F";
    statut: StagiaireStatus;
    visio: boolean;

    photoPro: Photo | null;

    lieuxActivite: ActivityLocation[];

    presenceWebs: WebLink[];

    passageCertifications: CertificationExam[];
}

export interface ActivityLocation {
    id: number;
    pays: string;
    codePostal: string;
    ville: string;
}

export enum CertificationType {
    RS = "RS",
    RNCP = "RNCP"
}

export interface Certification {
    type: CertificationType;
    code: string;
    name: string;
}

export interface CertificationExam {
    dateDebutValidite: string;
    certification: Certification;
}

export interface Photo {
    url: string;
}

export interface WebLink {
    type: WebLinkType;
    url: string;
}

export enum WebLinkType {
    SiteWeb = "Site web",
    ReseauSocial = "Réseau social"
}